import React from 'react'
import classNames from 'classnames'
import Container from './container'
import Link from './link'

export default function CtaBold({ content, design }) {
  const { links } = content ?? {}
  const { theme } = design ?? {}

  return (
    links?.length && (
      <section
        className={classNames(
          'clown',
          { dark: 'border-secondary bg-secondary text-primary', light: 'border-secondary bg-primary text-secondary' }[theme]
        )}>
        <ul>
          {links.map(({ link }, index) => (
            <li
              key={index}
              className={classNames(
                'group first:border-t-2 border-b-2',
                { dark: 'border-primary text-primary fill-primary bg-secondary hover:border-secondary hover:bg-primary hover:text-secondary hover:fill-secondary', light: 'border-secondary text-secondary fill-secondary bg-primary hover:border-primary hover:bg-secondary hover:text-primary hover:fill-primary' }[theme]
              )}>
              <Link {...link} className="block py-8 md:py-12 control-4xl">
                <Container className="flex items-center justify-between">
                  <span className="inline-block">{link.title}</span>
                  <span className="inline-block group-hover:translate-x-3 transition duration-150 ease-[cubic-bezier(.47,.27,.28,.86)]">
                    <svg viewBox="0 0 63.8 49.4" className="mt-2 w-8 lg:w-11">
                      <path d="m26.2 42.5 32.3-16.8L0 29.1v-8.8l58.3 3.3L26.2 6.9 30.6 0l33.2 24.7-33.2 24.7-4.4-6.9Z" />
                    </svg>
                  </span>
                </Container>
              </Link>
            </li>
          ))}
        </ul>
      </section>
    )
  )
}
